import { motion } from "framer-motion"
import { StaticImage } from "gatsby-plugin-image"
import { Button } from "../../myne/Button/Button"
import useWindowDimensions from "../../utils/useWindowDimensions"

const OrganicReach = () => {
  const { width } = useWindowDimensions()
  const isMobileUp = width >= 768
  return (
    <section className="bg-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="relative">
          <motion.div
            animate={{ y: [0, -10, 0], scale: [1, 1.08, 1] }}
            transition={{ duration: 5, ease: "easeInOut", repeat: Infinity }}
            className="absolute -top-6 left-16 w-14 h-14 rounded-full pointer-events-none bg-gradient-to-br from-[#fff] to-[#F5D6FA] shadow-lg z-10 hidden md:block"
          />

          <motion.div
            animate={{ y: [0, 12, 0], scale: [1, 1.06, 1] }}
            transition={{
              duration: 6,
              ease: "easeInOut",
              repeat: Infinity,
              delay: 1,
            }}
            className="absolute top-[30%] -right-10 w-24 h-24 rounded-full pointer-events-none bg-gradient-to-r from-[#F5D6FA] to-[#fff] shadow-lg z-10 hidden md:block"
          />
          <div className="relative rounded-[30px] md:rounded-[40px] py-8 md:py-0 px-10 md:px-20 flex flex-row items-center md:min-h-[380px] bg-[#F1EBFF] overflow-hidden">
            <div className="absolute bottom-0 right-0 w-64 h-64 rounded-full pointer-events-none hidden md:block">
              <StaticImage
                src="../../images/vectors/wave-right.png"
                alt="Vector"
                width={512}
                quality={90}
              />
            </div>

            <div className="relative z-10 w-full">
              <h2 className="text-[22px] md:text-[42px] font-semibold text-gray-900 leading-tight mb-5 ">
                See What Organic Reach <br className="hidden md:block" />{" "}
                Actually Looks Like
              </h2>
              <p className="text-base md:text-lg text-gray-900 max-w-sm mb-8 leading-relaxed">
                Book a 20-minute demo. We'll show you what Premagic can do for
                your next event.
              </p>
              <Button to="/request-a-demo/">Book a Demo</Button>
            </div>

            {isMobileUp && (
              <div className="relative z-10 w-full md:w-1/2 flex justify-center items-end h-full self-end ">
                <StaticImage
                  src="../../images/organic-reach-image.png"
                  alt="People discussing a laptop"
                  className="!max-w-lg !w-[600px]  absolute bottom-0 -right-[40px]"
                  placeholder="blurred"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default OrganicReach
